import { Page } from '@roc/feature-app-core';
import { Route } from 'react-router';
import { CreditMemo } from '../components/creditMemo';

export const getUnderwriterWriteupInternalRoutesConfig = (
  basePath: string,
  baseUrl: string
) => {
  return {
    creditMemo: {
      path: `${basePath}/underwriter-writeup/credit-memo`,
      url: `${baseUrl}/underwriter-writeup/credit-memo`,
      documentTitle: 'Credit memo',
    },
  };
};

export const getUnderwriterWriteupInternalRoutes = (
  basePath: string,
  baseUrl: string
) => {
  const config = getUnderwriterWriteupInternalRoutesConfig(basePath, baseUrl);
  return {
    creditMemo: (
      <Route exact path={config.creditMemo.path}>
        <Page routeDefinition={config.creditMemo}>
          <CreditMemo />
        </Page>
      </Route>
    ),
  };
};
